import { IOptions } from './types';

export const enum ROUTES {
  HOME = '/home',
  DASHBOARD = '/dashboard',
  REPORT_INPUT = '/report-input',
  REPORT_PRODUCTION = '/report-production',
  REPORT_FINANCE = '/report-finance',
  PONDS = '/ponds',
  SUPPLIES = '/supplies',
  USER = '/user',
  USERS = '/users',
}

export const DEFAULT_OPTIONS: IOptions[] = [
  {
    id: 1,
    label: 'SUGESTÕES',
    value: 'default',
    prompt: 'default',
  },
];

export const OPTIONS: Record<ROUTES, IOptions[]> = {
  '/home': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'INSIGHTS SOBRE TODOS OS VIVEIROS',
      value: 'nurseries',
      prompt: 'ME DÊ INSIGHTS SOBRE TODOS OS VIVEIROS DISPONÍVEIS NA FAZENDA',
    },
    {
      id: 3,
      label: 'INSIGHTS SOBRE TODOS OS CICLOS',
      value: 'cycles',
      prompt: 'ME DÊ INSIGHTS SOBRE TODOS OS CICLOS DISPONÍVEIS NA FAZENDA',
    },
  ],
  '/dashboard': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'Gráfico de Insumos',
      value: 'graphicSupply',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE CONSUMO DE INSUMOS POR VIVEIROS',
    },
    {
      id: 3,
      label: 'Mortalidade por Viveiro',
      value: 'graphicNurseryMortality',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE MORTALDADE POR VIVEIROS',
    },
    {
      id: 4,
      label: 'Análise de Saúde',
      value: 'graphicHealthAnalysis',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE ANÁLISE DE SAÚDE DOS VIVEIROS',
    },
    {
      id: 5,
      label: 'Qualidade da Água por Parâmetros',
      value: 'graphicQualityParameters',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE QUALIDADE DA ÁGUA DOS VIVEIROS',
    },
    {
      id: 6,
      label: 'Biometria por Parâmetros',
      value: 'graphicBiometricsParameters',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE BIOMETRIA POR PARÂMETROS',
    },
    {
      id: 7,
      label: 'Biometria por Viveiros',
      value: 'graphicBiometricsNurseries',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE BIOMETRIA POR VIVEIROS',
    },
    {
      id: 8,
      label: 'Análise da Água por Viveiros',
      value: 'graphicWaterAnalysisNurseries',
      prompt:
        'ME DÊ INSIGHTS SOBRE TODOS OS DADOS DO GRÁFICO DE ANÁLISE DA ÁGUA POR VIVEIROS',
    },
  ],
  '/report-input': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'QUAL FOI O CONSUMO TOTAL NESTE PERÍODO?',
      value: '',
      prompt: 'Qual foi o consumo total neste período?',
    },
    {
      id: 3,
      label: 'QUAL É O INSUMO (PRODUTO) MAIS CONSUMIDO?',
      value: '',
      prompt: 'Qual é o insumo (produto) mais consumido?',
    },
    {
      id: 4,
      label: 'QUAL FOI O CONSUMO MÉDIO POR CICLO?',
      value: '',
      prompt: 'Qual foi o consumo médio por ciclo?',
    },
    {
      id: 5,
      label: 'QUAL FOI O CONSUMO MÉDIO POR VIVEIRO?',
      value: '',
      prompt: 'Qual foi o consumo médio por viveiro?',
    },
    {
      id: 6,
      label: 'QUAL CICLO TEVE O MAIOR CONSUMO?',
      value: '',
      prompt: 'Qual ciclo teve o maior consumo?',
    },
    {
      id: 7,
      label: 'QUAL VIVEIRO TEVE O MAIOR CONSUMO?',
      value: '',
      prompt: 'Qual viveiro teve o maior consumo?',
    },
    {
      id: 8,
      label: 'QUAL FOI O CONSUMO TOTAL POR INSUMO (PRODUTO)?',
      value: '',
      prompt: 'Qual foi o consumo total por insumo (produto)?',
    },
    {
      id: 9,
      label: 'QUAL FOI O CONSUMO TOTAL POR CICLO?',
      value: '',
      prompt: 'Qual foi o consumo total por ciclo?',
    },
  ],
  '/report-production': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label:
        'QUAL FOI O TANQUE COM MELHOR CONVERSÃO ALIMENTAR (FCR) NO ÚLTIMO CICLO?',
      value: '',
      prompt:
        'Qual foi o tanque com melhor conversão alimentar (FCR) no último ciclo?',
    },
    {
      id: 3,
      label:
        'QUAIS TANQUES APRESENTARAM AUMENTO NA MORTALIDADE ACIMA DA MÉDIA?',
      value: '',
      prompt:
        'Quais tanques apresentaram aumento na mortalidade acima da média?',
    },
    {
      id: 4,
      label:
        'QUAL ESPÉCIE TEVE O MELHOR DESEMPENHO EM TERMOS DE GANHO DE BIOMASSA?',
      value: '',
      prompt:
        'Qual espécie teve o melhor desempenho em termos de ganho de biomassa?',
    },
    {
      id: 5,
      label: 'QUAL É A TENDÊNCIA DA MORTALIDADE NOS ÚLTIMOS 3 MESES?',
      value: '',
      prompt: 'Qual é a tendência da mortalidade nos últimos 3 meses?',
    },
    {
      id: 6,
      label:
        'ESTAMOS CONSEGUINDO MELHORAR A CONVERSÃO ALIMENTAR AO LONGO DO TEMPO?',
      value: '',
      prompt:
        'Estamos conseguindo melhorar a conversão alimentar ao longo do tempo?',
    },
    {
      id: 7,
      label:
        'COM BASE NOS DADOS DE PRODUÇÃO, QUAL TANQUE DEVERIA RECEBER UMA ATENÇÃO ESPECIAL?',
      value: '',
      prompt:
        'Com base nos dados de produção, qual tanque deveria receber uma atenção especial?',
    },
    {
      id: 8,
      label:
        'VOCÊ RECOMENDA ALGUMA AÇÃO PARA MELHORAR O DESEMPENHO DA PRODUÇÃO?',
      value: '',
      prompt:
        'Você recomenda alguma ação para melhorar o desempenho da produção?',
    },
    {
      id: 9,
      label: 'DETECTE TANQUES COM MORTALIDADE FORA DO PADRÃO ESPERADO.',
      value: '',
      prompt: 'Detecte tanques com mortalidade fora do padrão esperado.',
    },
    {
      id: 10,
      label: 'EXISTE ALGUM TANQUE COM CONSUMO DE RAÇÃO FORA DO NORMAL?',
      value: '',
      prompt: 'Existe algum tanque com consumo de ração fora do normal?',
    },
  ],
  '/report-finance': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'QUAL FOI A RECEITA TOTAL NESTE PERÍODO?',
      value: '',
      prompt: 'Qual foi a receita total neste período?',
    },
    {
      id: 3,
      label: 'QUAL FOI O LUCRO CONSIDERANDO TODAS AS DESPESAS E RECEITAS?',
      value: '',
      prompt: 'Qual foi o lucro considerando todas as despesas e receitas?',
    },
    {
      id: 4,
      label: 'HOUVE ALGUMA DESPESA REGISTRADA NESTE RELATÓRIO?',
      value: '',
      prompt: 'Houve alguma despesa registrada neste relatório?',
    },
    {
      id: 5,
      label: 'O LUCRO CORRESPONDE A 100% DA RECEITA?',
      value: '',
      prompt: 'O lucro corresponde a 100% da receita?',
    },
    {
      id: 6,
      label:
        'EXISTE ALGUMA CONCENTRAÇÃO DE RECEITA EM POUCOS CENTROS DE CUSTO?',
      value: '',
      prompt:
        'Existe alguma concentração de receita em poucos centros de custo?',
    },
    {
      id: 7,
      label: 'QUAIS CENTROS DE CUSTO REPRESENTAM MAIS DE 20% DA RECEITA?',
      value: '',
      prompt: 'Quais centros de custo representam mais de 20% da receita?',
    },
  ],
  '/ponds': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'ESTAMOS UTILIZANDO A CAPACIDADE TOTAL DISPONÍVEL DOS VIVEIROS?',
      value: '',
      prompt: 'Estamos utilizando a capacidade total disponível dos viveiros?',
    },
    {
      id: 3,
      label:
        'QUAL A DISTRIBUIÇÃO DA CAPACIDADE ENTRE OS TIPOS DE VIVEIROS (PRÉ-BERÇÁRIO, BERÇÁRIO, ENGORDA)?',
      value: '',
      prompt:
        'Qual a distribuição da capacidade entre os tipos de viveiros (Pré-Berçário, Berçário, Engorda)?',
    },
    {
      id: 4,
      label: 'EXISTE SUBUTILIZAÇÃO DE VIVEIROS COM ALTA CAPACIDADE?',
      value: '',
      prompt: 'Existe subutilização de viveiros com alta capacidade?',
    },
    {
      id: 5,
      label:
        'QUAL A PROPORÇÃO ENTRE VIVEIROS EXTENSIVOS E SEMI-INTENSIVOS NA ESTRUTURA ATUAL?',
      value: '',
      prompt:
        'Qual a proporção entre viveiros extensivos e semi-intensivos na estrutura atual?',
    },
    {
      id: 6,
      label:
        'ESTAMOS ALOCANDO CORRETAMENTE OS SISTEMAS PRODUTIVOS (EXTENSIVO, SEMI-INTENSIVO) DE ACORDO COM A CAPACIDADE DOS VIVEIROS?',
      value: '',
      prompt:
        'Estamos alocando corretamente os sistemas produtivos (extensivo, semi-intensivo) de acordo com a capacidade dos viveiros?',
    },
    {
      id: 7,
      label:
        'QUAL PROTOCOLO ESTÁ MAIS PRESENTE NA ESTRUTURA: BIOFLOCOS OU HETEROTRÓFICO? POR QUÊ?',
      value: '',
      prompt:
        'Qual protocolo está mais presente na estrutura: Bioflocos ou Heterotrófico? Por quê?',
    },
    {
      id: 8,
      label:
        'QUAL O IMPACTO DA ESCOLHA DE PROTOCOLO SOBRE A CAPACIDADE DOS VIVEIROS?',
      value: '',
      prompt:
        'Qual o impacto da escolha de protocolo sobre a capacidade dos viveiros?',
    },
    {
      id: 9,
      label:
        'É VIÁVEL PADRONIZAR OS PROTOCOLOS PARA OTIMIZAR O MANEJO TÉCNICO?',
      value: '',
      prompt:
        'É viável padronizar os protocolos para otimizar o manejo técnico?',
    },
    {
      id: 10,
      label:
        'HÁ VIVEIROS DE MESMO TIPO COM PROTOCOLOS DIFERENTES? ISSO IMPACTA NA PRODUTIVIDADE?',
      value: '',
      prompt:
        'Há viveiros de mesmo tipo com protocolos diferentes? Isso impacta na produtividade?',
    },
    {
      id: 11,
      label:
        'DEVEMOS CONVERTER VIVEIROS DE MENOR CAPACIDADE PARA OUTRO TIPO (EX: DE PRÉ-BERÇÁRIO PARA BERÇÁRIO)?',
      value: '',
      prompt:
        'Devemos converter viveiros de menor capacidade para outro tipo (ex: de Pré-Berçário para Berçário)?',
    },
    {
      id: 12,
      label:
        'COM A ESTRUTURA ATUAL, QUANTOS CICLOS DE ENGORDA PODEMOS REALIZAR POR ANO?',
      value: '',
      prompt:
        'Com a estrutura atual, quantos ciclos de engorda podemos realizar por ano?',
    },
    {
      id: 13,
      label:
        'QUAIS VIVEIROS ESTÃO MAIS ADEQUADOS PARA PRODUÇÃO INTENSIVA DE JUVENIS?',
      value: '',
      prompt: 'Quais viveiros estão mais',
    },
    {
      id: 14,
      label:
        'EXISTE SOBREPOSIÇÃO OU CONFLITO ENTRE TIPOS DE VIVEIROS E PROTOCOLOS APLICADOS?',
      value: '',
      prompt:
        'Existe sobreposição ou conflito entre tipos de viveiros e protocolos aplicados?',
    },
  ],
  '/supplies': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'QUAIS INSUMOS ESTÃO COM ESTOQUE ZERADO OU ABAIXO DO IDEAL?',
      value: '',
      prompt: 'Quais insumos estão com estoque zerado ou abaixo do ideal?',
    },
    {
      id: 3,
      label: 'QUAL É O INSUMO COM A MAIOR QUANTIDADE EM ESTOQUE ATUALMENTE?',
      value: '',
      prompt: 'Qual é o insumo com a maior quantidade em estoque atualmente?',
    },
    {
      id: 4,
      label:
        'QUAL A QUANTIDADE TOTAL DE CADA TIPO DE INSUMO (POR EXEMPLO, QUILOGRAMA, MILILITRO, TONELADA)?',
      value: '',
      prompt:
        'Qual a quantidade total de cada tipo de insumo (por exemplo, Quilograma, Mililitro, Tonelada)?',
    },
    {
      id: 5,
      label: 'QUAL É O CUSTO TOTAL ESTIMADO DOS INSUMOS ATUALMENTE ESTOCADOS?',
      value: '',
      prompt: 'Qual é o custo total estimado dos insumos atualmente estocados?',
    },
    {
      id: 6,
      label: 'QUAIS SÃO OS INSUMOS MAIS CAROS CADASTRADOS?',
      value: '',
      prompt: 'Quais são os insumos mais caros cadastrados?',
    },
    {
      id: 7,
      label:
        'BASEADO NOS INSUMOS ZERADOS, QUAL SERIA UMA LISTA DE COMPRAS SUGERIDA?',
      value: '',
      prompt:
        'Baseado nos insumos zerados, qual seria uma lista de compras sugerida?',
    },
    {
      id: 8,
      label:
        'COM BASE NA UNIDADE DE MEDIDA, QUAL LOGÍSTICA SERIA IDEAL PARA REABASTECIMENTO?',
      value: '',
      prompt:
        'Com base na unidade de medida, qual logística seria ideal para reabastecimento?',
    },
    {
      id: 9,
      label:
        'QUAIS INSUMOS TÊM ESTOQUE, MAS NÃO TÊM DESCRIÇÃO — E POR ISSO PODEM PRECISAR DE VERIFICAÇÃO ANTES DO USO?',
      value: '',
      prompt:
        'Quais insumos têm estoque, mas não têm descrição — e por isso podem precisar de verificação antes do uso?',
    },
  ],
  '/user': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'CRIAR USUÁRIO',
      value: 'users',
      prompt:
        'Como base nos meus usuários, quais sugestões você tem para criar um usuário?',
    },
    {
      id: 3,
      label: 'EDITAR USUÁRIO',
      value: 'users',
      prompt:
        'Como base nos meus usuários, quais sugestões você tem para editar um usuário existente?',
    },
  ],
  '/users': [
    {
      id: 1,
      label: 'SUGESTÕES',
      value: 'default',
      prompt: '',
    },
    {
      id: 2,
      label: 'GESTÃO DE USUÁRIOS',
      value: '',
      prompt: 'Quais sugestões você tem para melhorar a gestão de usuários?',
    },
    {
      id: 3,
      label: 'INSIGHTS SOBRE USUÁRIOS',
      value: 'users',
      prompt:
        'Quais insights você pode fornecer sobre os usuários cadastrados?',
    },
  ],
};

export const getOptionsByRoute = (route: string): IOptions[] => {
  return OPTIONS[route as ROUTES] || DEFAULT_OPTIONS;
};
